import { HT, SITE_ORIGIN } from "../siteConfig";
import SEO from "../components/seo.jsx"
import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ── Hero / Doctor images ──
import HeroImg    from "../assets/aboutPage.png";  
import DrBhavesh  from "../assets/drbhaveshgupta.jpeg";

// ── Before / After gallery images ──
import GalleryImg1 from "../assets/gallery/client1.jpeg";
import GalleryImg2 from "../assets/gallery/client2.jpeg";
import GalleryImg3 from "../assets/gallery/client3.jpeg";
import GalleryImg4 from "../assets/gallery/client5.jpeg";

gsap.registerPlugin(ScrollTrigger);
const cinzel = { fontFamily: "'Cinzel', serif" };

/* ============================================================
   PAGE DATA swap this object to create a new city page
============================================================ */
const PAGE = {
  hero: {
    eyebrow: HT.menu,
    heading: "Hair Transplant in Mumbai",
    sub: "Clinique Internationale affordable cost, world-class expertise and natural-looking results in the city of dreams.",
  },

  breadcrumb: [
    { label: "Home", href: "/" },
    { label: HT.menu, href: null },
    { label: "Hair Transplant in Mumbai", href: null },
  ],

  /* ── SECTION 1 Best HT in Mumbai (intro) ── */
  intro: {
    eyebrow: "Overview",
    heading: "Best Hair Transplant in Mumbai",
    paragraphs: [
      "Clinique Internationale Clinic offers the best hair transplant in Mumbai, performed by the experienced Dr. Bhavesh Gupta. The hair transplant cost in Mumbai is quite affordable, with each hair graft typically priced between ₹50 and ₹150. The cost can vary depending on the technique used, the clinic's location, and the surgeon's expertise. At Clinique Internationale, we use unique and advanced methods, which deliver natural-looking results.",
      "Mumbai, also known as Bombay, is the capital of Maharashtra and the seventh most populated city in India. It is the country's financial, commercial, and entertainment hub. Mumbai, also known as the city of dreams and Bollywood stars, attracts many people who come here to try their luck and make a living. The city's vibe is filled with a sense of style and beauty. It's not just celebrities who care about aesthetics even everyday people in Mumbai pay a lot of attention to how things look.",
      "Cosmetic surgery has become a big business in Mumbai, with clinics offering a wide range of procedures at every corner. Among these, hair transplant in Mumbai is especially popular. The high demand for this procedure can be linked to many actors, both struggling and successful, who come to Mumbai to pursue their dreams. Additionally, hair loss is common in the city due to factors like pollution and the stressful lifestyle. As a result, hair transplant clinics are in high demand, catering to both locals and celebrities.",
      "Mumbai is home to some of the best hair transplant clinics in India, offering top-quality services that meet international standards. While some clinics may be expensive due to the city's high living costs, there are also options that provide excellent treatments at affordable prices. One such clinic is Clinique Internationale, known for delivering outstanding hair transplant services without the hefty price tag. They focus on providing the best care, making it accessible to more people looking for effective solutions.",
      "Mumbai stands out as one of the best cities for hair transplants, thanks to its highly skilled, world-class surgeons who provide exceptional results at competitive prices. The city attracts individuals from all over the country who are looking for the best hair restoration options. Mumbai's reputation for advanced techniques and affordable hair transplant costs makes it a leading destination for those suffering from hair loss.",
    ],
    stats: [
      { val: "₹50+",  sub: "Per graft starting cost" },
      { val: "15+",   sub: "Years of Dr. Gupta's experience" },
      { val: "98.5%", sub: "Graft survival rate" },
      { val: "10,000+", sub: "Successful procedures" },
    ],
  },

  /* ── SECTION 2 Surgeon ── */
  surgeon: {
    eyebrow: "Lead Surgeon",
    heading: "Hair Transplant Surgeon in Mumbai",
    paragraphs: [
      "If you're looking for a skilled and affordable hair transplant, Dr. Bhavesh Gupta at Clinique Internationale Hair Transplant Clinic is a great choice. He is known for his expertise and perfectionism, making him one of the top hair transplant surgeons in Mumbai.",
      "Dr. Bhavesh Gupta is a highly experienced hair transplant specialist in Mumbai, with over 15 years of experience, including 9 years as a specialist. He holds an Advanced Fellowship in Cosmetic Surgery and is well-known for his care and dedication to his patients. Dr. Gupta is passionate about providing personalised treatments that are tailored to each patient's unique needs.",
      "He is one of the top hair transplant surgeons in the country, with a reputation that is recognised and praised worldwide. His incredible surgical skills and artistic vision have helped him achieve amazing results in hair transplants. He believes in personally performing every hair transplant surgery to ensure the best results. Unlike other well-known clinics that rely on the reputation of their surgeons, he focuses on giving individual attention to each procedure.",
      "Even though he is highly respected and recognised around the world, he is very caring towards his patients. He takes the time to answer all of their questions patiently, ensuring they fully understand everything. He stays up-to-date with the latest techniques being used worldwide and has incorporated them into his daily practice. As a result, he has received great appreciation from both national and international patients, including celebrities.",
      "If you're looking for an expert hair transplant doctor in Mumbai, Dr. Bhavesh Gupta is definitely worth considering. You can trust him to deliver the best results and help you achieve the hair transplant outcomes you're hoping for.",
    ],
    tags: [ "Advanced Fellowship – Cosmetic Surgery", "AOMSI Member", "15+ Yrs Experience", "10,000+ Cases"],
  },

  /* ── SECTION 3 Cost Table ── */
  costSection: {
    eyebrow: "Pricing",
    heading: "Hair Transplant Cost in Mumbai",
    paragraphs: [
      "Hair transplant procedures in Mumbai are becoming increasingly popular, with a wide range of options available to those looking to restore their hair. At Clinique Internationale, the hair transplant cost in Mumbai starts from ₹50 per graft, making it one of the most affordable clinics in the city. Depending on the number of grafts required, the total cost typically ranges from ₹30,000 to ₹1,50,000. This makes Clinique Internationale a great option for individuals seeking high-quality treatment at competitive prices.",
      "Compared to other hair transplant clinics in Mumbai, which often charge higher prices for similar services, Clinique Internationale stands out due to its balance of affordability and quality. While other clinics may charge ₹70 to ₹150 per graft or more, the pricing at Clinique Internationale allows patients to receive world-class care without the financial strain.",
      "Moreover, Clinique Internationale offers advanced techniques, personalised consultations, and experienced professionals, ensuring a safe and effective procedure. Whether you're looking for a small or large hair transplant, Clinique Internationale provides excellent value for those seeking to restore their hair at an affordable cost.",
    ],
    tableHeads: ["Number of Grafts", "Average FUE Cost", "Average FUT Cost"],
    tableRows: [
      { grafts: "500 – 1,000",   fue: "₹50,000 – ₹60,000",    fut: "₹30,000 – ₹40,000"  },
      { grafts: "1,000 – 1,500", fue: "₹60,000 – ₹80,000",    fut: "₹37,000 – ₹60,000"  },
      { grafts: "1,500 – 2,000", fue: "₹70,000 – ₹90,000",    fut: "₹65,000 – ₹80,000"  },
      { grafts: "2,000 – 2,500", fue: "₹75,000 – ₹1,00,000",  fut: "₹70,000 – ₹95,000"  },
      { grafts: "2,500 – 3,000", fue: "₹1,20,000 – ₹1,50,000",fut: "₹1,00,000 – ₹1,20,000" },
    ],
    note: "For the exact cost, please contact our clinic directly.",
  },

  /* ── SECTION 4 Best Clinic in Mumbai ── */
  bestClinic: {
    eyebrow: "About Clinique Internationale",
    heading: "Best Hair Transplant Clinic in Mumbai",
    paragraphs: [
      "Hair loss is common in Mumbai, the 'city of dreams.' The fast-paced lifestyle here is quite different from other cities. Factors like busy nightlife, high stress levels, humid weather, pollution, and lifestyle choices, combined with genetics, can all contribute to baldness.",
      "Hair transplants in Mumbai are becoming very popular because more and more people are looking for a permanent solution to hair loss. As people become more aware of their appearance, the demand for this treatment is growing.",
      "Many people dream of getting a hair transplant after hearing about others' successful experiences. However, the high cost of hair transplants in other cities can make this dream difficult to achieve for many. Thankfully, the growing hair transplant industry in Mumbai now offers a great alternative, allowing people to get world-class hair transplants at a more affordable price.",
      "At Clinique Internationale Hair Transplant Clinic, we help many patients from all over India achieve excellent hair transplant results at a very affordable price. While many patients say cost is important, they choose Clinique Internationale for the overall experience, which they find remarkable.",
      "If the cost is stopping you from getting a hair transplant, don't worry! At Clinique Internationale Hair Transplant Clinic in Mumbai, you can get top-quality treatment with great results at an affordable price.",
    ],
  },

  /* ── SECTION 5 Methods ── */
  methods: [
    {
      title: "Follicular Unit Extraction (FUE)",
      href: "/follicular-unit-extraction.php",
      desc: "FUE hair transplant is a minimally invasive procedure where individual hair follicles are harvested from the donor area and meticulously transplanted to the balding or thinning areas, resulting in natural-looking and permanent hair restoration.",
    },
    {
      title: "Follicular Unit Transplantation (FUT)",
      href: "/follicular-unit-transplant.php",
      desc: "FUT involves surgically removing a strip of scalp from the donor area, dissecting it into individual follicular units, and transplanting them to the recipient site, providing an effective solution for hair loss and achieving natural-looking results.",
    },
    {
      title: "DHI Hair Transplant",
      href: null,
      desc: "Direct Hair Implantation (DHI) is an advanced hair transplant technique where individual hair follicles are extracted one by one from the donor area and directly implanted into the recipient site using a specialised tool, ensuring precise placement and minimal handling for a natural-looking result.",
    },
  ],

  /* ── SECTION 6 Types ── */
  types: [
    { num: "01", title: "Male Hair Transplant", href: "/male-hair-transplants.php", desc: "At Clinique Internationale, our male hair transplant services encompass advanced techniques such as FUE, FUT, and DHI. With personalised solutions, we restore hair effectively, ensuring natural-looking results and boosting confidence." },
    { num: "02", title: "Female Hair Transplant", href: "/female-hair-transplants.php", desc: "Clinique Internationale specialises in female hair transplants, employing advanced methods like FUE, FUT, and DHI. Tailored to individual needs, our services ensure natural and aesthetically pleasing results, addressing female hair loss with precision and expertise." },
    { num: "03", title: "Beard Hair Transplant", href: "/beard-hair-transplants.php", desc: "Clinique Internationale excels in beard hair transplants, utilising innovative techniques for natural and well-defined results. Our specialised procedures cater to diverse beard restoration needs, ensuring satisfaction and confidence in appearance." },
    { num: "04", title: "Eyebrow Hair Transplant", href: "/eyebrow-hair-transplants.php", desc: "Clinique Internationale specialises in eyebrow hair transplants, offering precision and natural aesthetics. Our procedures are tailored to enhance eyebrow density, shape, and symmetry, providing clients with confidence in their appearance." },
    { num: "05", title: "Eyelash Hair Transplant", href: "/eyelash-hair-transplants.php", desc: "Clinique Internationale excels in eyelash hair transplants, delivering precise and natural results. Our specialised procedures enhance eyelash density, providing clients with beautiful, long-lasting lashes and boosting confidence in their appearance." },
  ],

  /* ── SECTION 7 Stages of Hair Loss ── */
  stages: [
    { stage: "Stage 1–2", label: "Minimal Hair Loss",     desc: "At this stage, individuals might notice slight hair thinning or receding hairlines. It's crucial to address these early signs promptly to prevent further progression." },
    { stage: "Stage 3–4", label: "Noticeable Hair Loss",   desc: "Significant hair loss becomes apparent in this stage, often accompanied by increased shedding. Individuals may observe wider areas of thinning, requiring attention to maintain hair health." },
    { stage: "Stage 4–5", label: "Moderate Baldness",      desc: "Moderate baldness involves more noticeable hair loss, with larger areas of the scalp becoming visibly sparse. Seeking professional advice and exploring treatment options is advisable at this juncture." },
    { stage: "Stage 5–6", label: "Advanced Hair Thinning", desc: "In this advanced stage, substantial balding occurs, affecting the overall appearance. Hair follicles become finer, and covering bald spots becomes challenging without intervention." },
    { stage: "Stage 6–7", label: "Complete Baldness",      desc: "The final stage represents complete baldness, where only a few sparse hairs remain or none at all. Embracing one's baldness or exploring advanced restoration methods are common choices at this stage." },
  ],

  /* ── SECTION 8 Why Clinique ── */
  whyClinique: [
    { num: "01", title: "Expertise and Experience", desc: "At the core of Clinique Internationale's reputation is a team of highly skilled hair transplant surgeons. With years of expertise in the field, these hair transplant specialists are dedicated to delivering exceptional results." },
    { num: "02", title: "Personalised Treatment Plan", desc: "Understanding that each individual's hair loss journey is unique, Clinique Internationale places great emphasis on personalised treatment plans. Before embarking on any procedure, clients undergo thorough consultations with the clinic's specialists." },
    { num: "03", title: "Patient-Centric Approach", desc: "Client satisfaction is at the forefront of Clinique Internationale's mission. The clinic's patient-centric approach is evident from the moment individuals step through the door." },
    { num: "04", title: "Transparent Pricing", desc: "Clinique Internationale believes in transparency, especially when it comes to pricing. The clinic provides detailed and transparent hair transplant cost information, ensuring that clients are fully aware of the financial aspects of their chosen procedures." },
    { num: "05", title: "Positive Client Testimonials", desc: "The success of any clinic is best measured by the satisfaction of its clients. Clinique Internationale boasts a wealth of positive client testimonials attesting to the efficacy of its services." },
  ],

  /* ── GALLERY ── */
  gallery: [
    { img: GalleryImg1, alt: "Hair Transplant Before After – Akshay Joshi, Mumbai" },
    { img: GalleryImg2, alt: "Hair Transplant Before After – Abhay Patil, Mumbai"  },
    { img: GalleryImg3, alt: "Hair Transplant Before After – Akhil Mahajan, Mumbai" },
    { img: GalleryImg4, alt: "Hair Transplant Before After – Amit Parihar, Mumbai" },
  ],

  /* ── FAQs ── */
  faqs: [
    {
      q: "Is Mumbai good for hair transplant?",
      a: "Mumbai is a reputable destination for hair transplants, offering skilled surgeons and advanced facilities. The city's medical expertise and infrastructure make it a favourable choice for individuals seeking effective hair restoration procedures.",
    },
    {
      q: "How much does it cost for a hair transplant in Mumbai?",
      a: "Hair transplant costs in Mumbai vary but generally range from INR 40,000 to INR 1,50,000. Factors like clinic reputation, surgeon expertise, and the number of grafts impact the final cost.",
    },
    {
      q: "How much does 1,500 hair grafts cost in Mumbai?",
      a: "The cost of 1,500 hair grafts in Mumbai typically ranges from INR 60,000 to INR 1,50,000, depending on factors such as clinic reputation, surgeon expertise, and additional services provided.",
    },
    {
      q: "Who is the best hair transplant surgeon in Mumbai?",
      a: "When it comes to finding the best hair transplant surgeon in Mumbai, the quest for excellence often leads to one name: Dr. Bhavesh Gupta renowned for his exceptional skills, unmatched expertise, and a track record of successful hair transplant procedures.",
    },
    {
      q: "Which is the best hair transplant clinic in Mumbai?",
      a: "Clinique Internationale stands out as the premier hair transplant clinic in Mumbai, known for its state-of-the-art facilities, expert medical professionals, and a track record of delivering exceptional, natural-looking results.",
    },
  ],

  cta: {
    eyebrow: "Take the First Step",
    heading: "Begin Your Hair Restoration Journey",
    sub: "Book a personalised consultation with Dr. Bhavesh Gupta at our Mumbai clinic. Get an accurate graft count, cost estimate and treatment plan all in one visit.",
    primary:   { label: "Book Consultation", href: "/khargharNaviMumbai.php" },
    secondary: { label: "View All Treatments", href: "/about-hair-transplants.php" },
  },
};

/* ============================================================
   REUSABLE SUB-COMPONENTS
============================================================ */
function Eyebrow({ children, light = false }) {
  return (
    <p style={cinzel} className={`text-[10.5px] tracking-[0.28em] uppercase mb-3 flex items-center justify-center gap-2.5 ${light ? "text-[#c9a84c]/70" : "text-[#a07828]"}`}>
      <span className={`w-6 h-px ${light ? "bg-[#c9a84c]/50" : "bg-[#c9a84c]"}`} />
      {children}
    </p>
  );
}
function EyebrowLeft({ children }) {
  return (
    <p style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase text-[#a07828] mb-3 flex items-center gap-2.5">
      <span className="w-6 h-px bg-[#c9a84c]" />{children}
    </p>
  );
}
function SectionHeading({ children, light = false, left = false }) {
  return (
    <h2 style={cinzel} className={`font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.85rem] uppercase tracking-[0.05em] mb-8 leading-tight ${light ? "text-white" : "text-[#1a0f02]"} ${left ? "text-left" : "text-center"}`}>
      {children}
    </h2>
  );
}
function GoldDivider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent" />;
}
function Card({ children, className = "" }) {
  return (
    <div className={`bg-white border border-[#c9a84c]/18 rounded-2xl relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300 ${className}`}>
      <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
      {children}
    </div>
  );
}
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border rounded-xl overflow-hidden transition-colors duration-300 ${open ? "border-[#c9a84c]/40 bg-[#c9a84c]/[0.04]" : "border-[#c9a84c]/15 bg-white"}`}>
      <button className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-5 text-left" onClick={() => setOpen(p => !p)}>
        <span style={cinzel} className="text-[13px] font-bold tracking-[0.04em] text-[#1a0f02]">{q}</span>
        <span className={`flex-shrink-0 w-7 h-7 rounded-full border border-[#c9a84c]/35 flex items-center justify-center transition-transform duration-300 ${open ? "rotate-45 bg-[#c9a84c] border-[#c9a84c]" : ""}`}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 2v8M2 6h8" stroke={open ? "#1a0f02" : "#c9a84c"} strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </span>
      </button>
      {open && <div className="px-5 sm:px-6 pb-5"><p className="text-[13.5px] leading-[1.8] text-[#6b5535]">{a}</p></div>}
    </div>
  );
}

/* ============================================================
   LIGHTBOX for gallery
============================================================ */
function Lightbox({ img, alt, onClose }) {
  useEffect(() => {
    const handler = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);
  return (
    <div className="fixed inset-0 bg-black/90 z-[9999] flex items-center justify-center p-4" onClick={onClose}>
      <div className="relative max-w-3xl w-full" onClick={e => e.stopPropagation()}>
        <button onClick={onClose} className="absolute -top-10 right-0 text-white/70 hover:text-white text-2xl px-2 leading-none">✕ Close</button>
        <img src={img} alt={alt} className="w-full rounded-xl" />
      </div>
    </div>
  );
}

const cityUrls = {
  "Airoli": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-airoli-hair-transplant-planned-around-your-it-schedule/",
  "CBD Belapur": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-cbd-belapur-expert-hair-clinic-next-door/",
  "Nerul": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-nerul-surgeon-led-hair-restoration-for-students-and-athletes/",
  "Sanpada": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-sanpada-thoughtful-hair-restoration-for-every-age/",
  "Seawoods": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-seawoods-natural-results-15-minutes-away/",
  "Ulwe": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-ulwe-hair-restoration-centre-for-navi-mumbais-airport-node/",
  "Vashi": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-vashi-specialist-hair-transplant-clinic-near-vashi/",
  "Ghansoli": "https://www.hairclinique.in/blog/navi-mumbai/hair-transplant-in-ghansoli-hair-beard-and-eyebrow-transplant/",
  "Kamothe": "https://www.hairclinique.in/blog/navi-mumbai/hair-transplant-in-kamothe-hair-transplant-prp-and-hair-loss-treatment-10-minutes-away/",
  "Kopar Khairane": "https://www.hairclinique.in/blog/navi-mumbai/hair-transplant-in-kopar-khairane-how-to-choose-the-right-clinic/",
  "Panvel": "https://www.hairclinique.in/blog/navi-mumbai/hair-transplant-in-panvel-clinique-internationale-20-minutes-away/",
  "Kharghar": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-kharghar-clinique-internationale/",
  "Ambernath": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-ambernath-hair-transplant-cost-value-and-emi-options-explained/",
  "Badlapur": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-badlapur-recovering-at-home-a-practical-aftercare-guide/",
  "Mira Road": "https://www.hairclinique.in/blog/navi-mumbai/best-hair-transplant-in-mira-road-why-patients-travel-to-kharghar-and-how-to-plan-the-trip/",
  "Dombivli": "https://www.hairclinique.in/blog/navi-mumbai/hair-transplant-in-dombivli-a-safety-first-guide-to-hair-transplant-complications/",
  "Ghodbunder Road": "https://www.hairclinique.in/blog/navi-mumbai/hair-transplant-in-ghodbunder-road-your-hair-transplant-journey-month-by-month/",
  "Kalyan": "https://www.hairclinique.in/blog/navi-mumbai/hair-transplant-in-kalyan-7-hair-transplant-myths-answered-by-dr-bhavesh-gupta/",
  "Thane": "https://www.hairclinique.in/blog/navi-mumbai/hair-transplant-in-thane-fue-dhi-and-sapphire-fue-by-dr-bhavesh-gupta/",
};

const locationGroups = [
  {
    title: "Navi Mumbai",
    locations: [
      "Kharghar", "Panvel", "Vashi", "Seawoods",
      "Ulwe", "Nerul", "CBD Belapur", "Sanpada",
      "Airoli", "Ghansoli", "Kopar Khairane", "Kamothe",
    ],
  },
  {
    title: "Thane & Beyond",
    locations: [
      "Thane", "Ghodbunder Road", "Kalyan", "Dombivli",
      "Mira Road", "Bhayandar", "Ambernath", "Badlapur",
    ],
  },
  {
    title: "South Mumbai",
    locations: [
      "Colaba", "Cuffe Parade", "Nariman Point",
      "Churchgate", "Marine Drive", "Malabar Hill",
      "Breach Candy", "Tardeo",
    ],
  },
  {
    title: "Central Mumbai & Central Suburbs",
    locations: [
      "Worli", "Lower Parel", "Dadar", "Wadala",
      "Sion", "Chembur", "Kurla", "Ghatkopar",
      "Powai", "Mulund",
    ],
  },
  {
    title: "Western Suburbs",
    locations: [
      "Bandra", "Khar", "Santacruz", "Juhu",
      "Vile Parle", "Andheri", "Jogeshwari",
      "Goregaon", "Malad", "Kandivali",
      "Borivali", "Dahisar",
    ],
  },
];


/* ============================================================
   PAGE COMPONENT
============================================================ */
export default function HairTransplantMumbai() {
  const pageRef    = useRef(null);
  const heroEyeRef = useRef(null);
  const heroHdRef  = useRef(null);
  const heroSubRef = useRef(null);
  const secRefs    = useRef([]);
  const addRef     = (el) => el && !secRefs.current.includes(el) && secRefs.current.push(el);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";
      gsap.fromTo(heroEyeRef.current, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease });
      gsap.fromTo(heroHdRef.current,  { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.75, ease, delay: 0.1 });
      gsap.fromTo(heroSubRef.current, { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.7, ease, delay: 0.18 });
      secRefs.current.forEach(el => {
        if (!el) return;
        gsap.fromTo(el, { opacity: 0, y: 36 }, {
          opacity: 1, y: 0, duration: 0.75, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" },
        });
      });
    }, pageRef);
    return () => ctx.revert();
  }, []);

  const wrap = "max-w-6xl mx-auto px-5 sm:px-8 lg:px-12";
  const sec  = "py-16 sm:py-20 md:py-24";

  return (
    <>
    <SEO
  title="Hair Transplant in Mumbai & Navi Mumbai | Clinique Internationale"
  description="Expert hair transplant in Mumbai and Navi Mumbai at Clinique Internationale, led by Dr. Bhavesh Gupta. Advanced FUE/FUT techniques, natural, lasting results."
  url={`${SITE_ORIGIN}/hair-transplant-in-mumbai.php`}
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />

      {lightbox && <Lightbox img={lightbox.img} alt={lightbox.alt} onClose={() => setLightbox(null)} />}

<div ref={pageRef} className="relative w-full bg-[#f2ece0] overflow-hidden mt-16 lg:mt-20" style={{ fontFamily: "'Raleway', sans-serif" }}>

  {/* ══════════════════════════════════════
      HERO
  ══════════════════════════════════════ */}
  <div className="relative h-[200px] xs:h-[280px] sm:h-[360px] md:h-[700px] flex items-center justify-end overflow-hidden">
    <img className="absolute inset-0 w-full h-full object-cover object-[center_20%]" src={HeroImg} alt="Best Hair Transplant in Mumbai" />
    <div className="absolute inset-0" />
    <div className="absolute inset-0 opacity-40 pointer-events-none"
      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E\")" }}
    />
    <div className="relative z-10 text-right px-4 sm:px-10 md:px-16 max-w-[85%] sm:max-w-xl">
      <p ref={heroEyeRef} style={cinzel} className="text-[8px] xs:text-[9px] sm:text-[10.5px] tracking-[0.2em] xs:tracking-[0.24em] sm:tracking-[0.32em] uppercase text-[#c9a84c] mb-2 sm:mb-4 flex items-center justify-end gap-2 sm:gap-3">
        <span className="w-4 sm:w-7 h-px bg-[#c9a84c]" />{PAGE.hero.eyebrow}<span className="w-4 sm:w-7 h-px bg-[#c9a84c]" />
      </p>
      <h1 ref={heroHdRef} style={cinzel} className="font-black text-[0.8rem] xs:text-[1.8rem] sm:text-[2.8rem] md:text-[3.6rem] tracking-[0.02em] sm:tracking-[0.04em] uppercase text-white mb-2 sm:mb-3 leading-[1.15] sm:leading-tight">
        {PAGE.hero.heading}
      </h1>
      <p ref={heroSubRef} className="text-[11px] xs:text-[12px] sm:text-[15px] text-white/70 leading-relaxed ml-auto">{PAGE.hero.sub}</p>
    </div>
  </div>

        {/* BREADCRUMB */}
        <div className="bg-[#0e0905]/95 border-b border-[#c9a84c]/10">
          <div className={`${wrap} py-3 flex flex-wrap items-center gap-2`}>
            {PAGE.breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-[#c9a84c]/30 text-xs">›</span>}
                {b.href
                  ? <a href={b.href} style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]/60 hover:text-[#c9a84c] transition-colors">{b.label}</a>
                  : <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]">{b.label}</span>}
              </span>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 1 INTRO text flows full width,
            wraps around a floated image + stats block
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <EyebrowLeft>{PAGE.intro.eyebrow}</EyebrowLeft>
            <SectionHeading left>{PAGE.intro.heading}</SectionHeading>

            {/* image + stats float right on desktop text wraps around it, then
                expands to the full container width once the paragraphs run
                past the block's height, so there's no leftover empty space. */}
            <div className="md:float-right md:w-[360px] md:ml-10 mb-8 flex flex-col gap-5">
              <div
                className="relative overflow-hidden rounded-2xl border border-[#c9a84c]/25 cursor-pointer group"
                onClick={() => setLightbox(PAGE.gallery[0])}
              >
                <img src={PAGE.gallery[0].img} alt={PAGE.gallery[0].alt} className="w-full h-[200px] object-cover group-hover:scale-[1.03] transition-transform duration-500" />
                <div className="absolute inset-0 bg-[#0e0905]/0 group-hover:bg-[#0e0905]/30 transition-colors flex items-center justify-center">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity w-12 h-12 rounded-full bg-white/20 border border-white/50 flex items-center justify-center">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 9h12M9 3v12" stroke="white" strokeWidth="2" strokeLinecap="round"/></svg>
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 bg-[#0e0905]/70 border border-[#c9a84c]/30 rounded-lg px-3 py-1.5 backdrop-blur-sm">
                  <p style={cinzel} className="text-[10px] tracking-[0.1em] uppercase text-[#c9a84c]">Before / After · Mumbai</p>
                </div>
              </div>
              {/* stats card */}
              <div className="relative overflow-hidden bg-[#0e0905] border border-[#c9a84c]/20 rounded-2xl p-6">
                <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent" />
                <div className="grid grid-cols-2 gap-5">
                  {PAGE.intro.stats.map((s) => (
                    <div key={s.val}>
                      <div style={cinzel} className="font-black text-[1.55rem] leading-none mb-1 bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{s.val}</div>
                      <div className="text-[11.5px] text-white/45 leading-snug">{s.sub}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* paragraphs flow full-width, wrapping around the floated block above */}
            {PAGE.intro.paragraphs.map((p, i) => (
              <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] mb-4">{p}</p>
            ))}
            <div className="clear-both" />
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 2 SURGEON
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef} className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 items-start">
              {/* text */}
              <div>
                <Eyebrow light>{PAGE.surgeon.eyebrow}</Eyebrow>
                <SectionHeading light left>{PAGE.surgeon.heading}</SectionHeading>
                {PAGE.surgeon.paragraphs.map((p, i) => (
                  <p key={i} className="text-[14px] leading-[1.9] text-white/60 mb-4">{p}</p>
                ))}
                <div className="flex flex-wrap gap-2 mt-5">
                  {PAGE.surgeon.tags.map(t => (
                    <span key={t} style={cinzel} className="text-[9.5px] tracking-[0.12em] uppercase text-[#c9a84c]/90 border border-[#c9a84c]/25 rounded px-3 py-1">{t}</span>
                  ))}
                </div>
              </div>
              {/* doctor image */}
              <div className="relative overflow-hidden rounded-2xl border-2 border-[#c9a84c]/40 md:mt-14">
                <img src={DrBhavesh} alt="Hair Transplant Specialist in Mumbai – Dr. Bhavesh Gupta" className="w-full h-auto object-contain object-top" style={{ maxHeight: "420px" }} />
                <div className="absolute bottom-3 left-3 bg-[#0e0905]/80 border border-[#c9a84c]/30 rounded-xl px-4 py-2.5 backdrop-blur-sm">
                  <p style={cinzel} className="text-[11px] font-bold tracking-[0.06em] text-white/90">Dr. Bhavesh Gupta</p>
                  <p className="text-[10.5px] text-[#c9a84c]/80 mt-0.5">Founder & Lead Surgeon</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SECTION 3 COST TABLE
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>{PAGE.costSection.eyebrow}</Eyebrow>
            <SectionHeading>{PAGE.costSection.heading}</SectionHeading>
            {PAGE.costSection.paragraphs.map((p, i) => (
              <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-4">{p}</p>
            ))}
            <div className="overflow-x-auto rounded-2xl border border-[#c9a84c]/20 shadow-[0_4px_24px_rgba(90,60,10,0.07)] mt-8 max-w-4xl mx-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[#0e0905]">
                    {PAGE.costSection.tableHeads.map(h => (
                      <th key={h} style={cinzel} className="text-left text-[11px] tracking-[0.1em] uppercase text-[#c9a84c] px-5 py-4 font-bold whitespace-nowrap">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {PAGE.costSection.tableRows.map((r, i) => (
                    <tr key={i} className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white" : "bg-[#f2ece0]/60"} hover:bg-[#c9a84c]/[0.05] transition-colors`}>
                      <td className="px-5 py-4 text-[13px] font-semibold text-[#1a0f02]">{r.grafts}</td>
                      <td className="px-5 py-4 text-[13px] font-bold text-[#1a0f02]">{r.fue}</td>
                      <td className="px-5 py-4 text-[13px] text-[#3a2e1e]">{r.fut}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="text-center text-[13px] text-[#6b5535] mt-4 italic">{PAGE.costSection.note}</p>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 4 BEST CLINIC
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow>{PAGE.bestClinic.eyebrow}</Eyebrow>
              <SectionHeading>{PAGE.bestClinic.heading}</SectionHeading>
              <div className="max-w-3xl mx-auto">
                {PAGE.bestClinic.paragraphs.map((p, i) => (
                  <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] mb-4">{p}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SECTION 5 METHODS
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>Techniques</Eyebrow>
            <SectionHeading>Methods of Hair Transplant</SectionHeading>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {PAGE.methods.map((m, i) => (
                <Card key={i} className="p-6">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#c9a84c]/10 to-[#c9a84c]/[0.03] border border-[#c9a84c]/20 flex items-center justify-center mb-4">
                    <span style={cinzel} className="font-black text-[12px] text-[#c9a84c]">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  {m.href
                    ? <a href={m.href} style={cinzel} className="text-[13.5px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] hover:text-[#a07828] transition-colors block mb-3">{m.title}</a>
                    : <div style={cinzel} className="text-[13.5px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] mb-3">{m.title}</div>}
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{m.desc}</p>
                </Card>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 6 TYPES (dark band)
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow light>Our Services</Eyebrow>
              <SectionHeading light>Types of Hair Transplants at Clinique Internationale</SectionHeading>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                {PAGE.types.map((t) => (
                  <a key={t.num} href={t.href}
                    className="relative overflow-hidden bg-gradient-to-br from-[#c9a84c]/[0.07] to-[#c9a84c]/[0.02] border border-[#c9a84c]/15 rounded-2xl p-6 hover:border-[#c9a84c]/30 hover:bg-[#c9a84c]/[0.1] transition-all duration-300 group block">
                    <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/35 to-transparent" />
                    <div className="flex items-center gap-3 mb-3">
                      <span style={cinzel} className="font-black text-[1.4rem] leading-none text-[#c9a84c]/25 select-none">{t.num}</span>
                      <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.05em] uppercase text-white/85 group-hover:text-[#ffe9a0] transition-colors">{t.title}</div>
                    </div>
                    <p className="text-[13px] leading-[1.75] text-white/50">{t.desc}</p>
                    <div className="mt-3 flex items-center gap-1.5">
                      <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]/60 font-bold">Learn More</span>
                      <span className="text-[#c9a84c]/60 text-xs">→</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SECTION 7 STAGES OF HAIR LOSS
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>Hair Loss Classification</Eyebrow>
            <SectionHeading>Stages of Hair Loss</SectionHeading>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {PAGE.stages.map((s, i) => (
                <Card key={i} className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div style={{ background: `rgba(201,168,76,${0.08 + i * 0.04})`, borderColor: `rgba(201,168,76,${0.2 + i * 0.06})` }}
                      className="w-12 h-12 rounded-full border flex items-center justify-center flex-shrink-0">
                      <span style={cinzel} className="font-black text-[11px] text-[#c9a84c]">{s.stage.replace("Stage ", "S")}</span>
                    </div>
                    <div style={cinzel} className="text-[13px] font-bold uppercase tracking-[0.04em] text-[#1a0f02]">{s.label}</div>
                  </div>
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{s.desc}</p>
                </Card>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 8 WHY CLINIQUE
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow>Why Choose Us</Eyebrow>
              <SectionHeading>Why Clinique Internationale is Best for Hair Transplant in Mumbai?</SectionHeading>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                {PAGE.whyClinique.map((w) => (
                  <Card key={w.num} className="p-6">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/15 to-[#c9a84c]/[0.03] border border-[#c9a84c]/20 flex items-center justify-center mb-4">
                      <span style={cinzel} className="text-[11px] font-black text-[#c9a84c]">{w.num}</span>
                    </div>
                    <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.06em] uppercase text-[#1a0f02] mb-2.5">{w.title}</div>
                    <p className="text-[13px] leading-[1.75] text-[#6b5535]">{w.desc}</p>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            BEFORE / AFTER GALLERY
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>Results</Eyebrow>
            <SectionHeading>Hair Transplant in Mumbai Before &amp; After</SectionHeading>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-5">
              {PAGE.gallery.map((g, i) => (
                <div key={i}
                  onClick={() => setLightbox(g)}
                  className="relative overflow-hidden rounded-2xl border border-[#c9a84c]/20 cursor-pointer group hover:border-[#c9a84c]/50 hover:shadow-[0_8px_28px_rgba(201,168,76,0.15)] transition-all duration-300 aspect-[4/5]"
                >
                  <img src={g.img} alt={g.alt} className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0e0905]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                    <span style={cinzel} className="text-[10px] tracking-[0.08em] uppercase text-[#c9a84c]">View Result</span>
                  </div>
                  <div className="absolute top-2.5 right-2.5 w-7 h-7 rounded-full bg-white/15 border border-white/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity backdrop-blur-sm">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M1.5 5.5h8M5.5 1.5v8" stroke="white" strokeWidth="1.6" strokeLinecap="round"/></svg>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            FAQs
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow>Common Questions</Eyebrow>
              <SectionHeading>Frequently Asked Questions</SectionHeading>
              <div className="max-w-3xl mx-auto flex flex-col gap-3">
                {PAGE.faqs.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} />)}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* MISSION STRIP */}
        <div className="bg-[#0e0905] py-14 sm:py-16">
          <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
            <p style={cinzel} className="text-[1rem] sm:text-[1.2rem] md:text-[1.35rem] font-light leading-[1.7] text-white/85 tracking-[0.02em]">
              "Mumbai is not just our home it is where we have built over two decades of trust, one{" "}
              <em className="italic" style={{ color: "#c9a84c" }}>natural hairline</em>{" "}
              at a time."
            </p>
            <p className="text-[11px] tracking-[0.18em] uppercase text-[#c9a84c]/50 mt-5">
             Dr. Bhavesh Gupta, Founder · Clinique Internationale
            </p>
          </div>
        </div>
        <GoldDivider />

        {/* CTA */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef} className="max-w-xl mx-auto text-center">
            <Eyebrow>{PAGE.cta.eyebrow}</Eyebrow>
            <h3 style={cinzel} className="font-black text-[1.3rem] sm:text-[1.65rem] md:text-[1.9rem] text-[#1a0f02] uppercase tracking-[0.06em] mb-3.5">{PAGE.cta.heading}</h3>
            <p className="text-[14px] text-[#6b5535] leading-[1.75] mb-8">{PAGE.cta.sub}</p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a href={PAGE.cta.primary.href}
                style={{ ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-md text-[#1a0f02] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] transition-all inline-block">
                {PAGE.cta.primary.label}
              </a>
              <a href={PAGE.cta.secondary.href}
                style={cinzel}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-[13px] rounded-md bg-transparent border border-[#1a0f02]/35 text-[#1a0f02] hover:-translate-y-0.5 hover:border-[#c9a84c] hover:text-[#a07828] transition-all inline-block">
                {PAGE.cta.secondary.label}
              </a>
            </div>
          </div>
        </div>

        
{/* HAIR TRANSPLANT LOCATIONS */}
<GoldDivider />

<section className="bg-[#faf8f4] py-8 sm:py-10">
  <div className={wrap}>
    <div className="text-center mb-10">
      <Eyebrow>Our Service Areas</Eyebrow>

      <SectionHeading>
        Hair Transplant in Mumbai & Nearby Locations
      </SectionHeading>

      <p className="max-w-2xl mx-auto text-sm leading-7 text-[#6b5535]">
        Explore hair transplant services across Navi Mumbai,
        Thane, South Mumbai, Central Mumbai and the Western Suburbs.
        Select your preferred location to learn more.
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {locationGroups.map((group) => (
        <div
          key={group.title}
          className="bg-white border border-[#c9a84c]/20 rounded-xl p-5 sm:p-6"
        >
          <h3
            style={cinzel}
            className="text-sm font-bold text-[#1a0f02] mb-4 pb-3 border-b border-[#c9a84c]/20"
          >
            {group.title}
          </h3>

          <ul className="space-y-2.5">
            {group.locations.map((location) => {
              const slug = location
                .toLowerCase()
                .replace(/&/g, "and")
                .replace(/\s+/g, "-");

              return (
                <li key={location}>
                  <a
                   href={cityUrls[location] || "#"}
                    className="group flex items-start gap-2 text-[13px] sm:text-sm text-[#6b5535] hover:text-[#a07828] transition-colors"
                  >
                    <span className="text-[#c9a84c] mt-0.5">
                      →
                    </span>

                    <span className="group-hover:underline underline-offset-4">
                      Hair Transplant in {location}
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  </div>
</section>

<GoldDivider />


      </div>
    </>
  );
}